import { ElkNode, ElkExtendedEdge } from "elkjs"
import { INode, IEdge } from "./flowAsDiagram"

export async function layout(nodes: INode[], edges: IEdge[]) {
  const { elkNodes: elkNodes, elkEdges: elkEdges } = convertToElkNotation(
    nodes,
    edges,
  )
  const rootElkNode: ElkNode = await performElk(elkNodes, elkEdges)
  const { nodes: updatedNodes, edges: updatedEdges } = convertToSoNotation(
    rootElkNode,
    nodes,
    edges,
  )
  return { nodes: updatedNodes, edges: updatedEdges }
}

function convertToElkNotation(
  nodes: INode[],
  edges: IEdge[],
): { elkNodes: ElkNode[]; elkEdges: ElkExtendedEdge[] } {
  const elkNodes: ElkNode[] = []
  const elkEdges: ElkExtendedEdge[] = []

  for (const node of nodes) {
    elkNodes.push({
      id: node.id,
      width: node.width,
      height: node.height,
    })
  }

  for (const edge of edges) {
    elkEdges.push({
      id: edge.id,
      sources: [edge.source.id],
      targets: [edge.target.id],
    })
  }

  return {
    elkNodes: elkNodes,
    elkEdges: elkEdges,
  }
}

async function performElk(
  elkNodes: ElkNode[],
  elkEdges: ElkExtendedEdge[],
): Promise<ElkNode> {
  const graph = {
    id: "root",
    layoutOptions: { "elk.algorithm": "layered" },
    children: elkNodes,
    edges: elkEdges,
  }

  const ELK = await import("elkjs") // This is a massive library, we want an async load.
  const elk = new ELK.default()
  return elk.layout(graph)
}

function convertToSoNotation(
  rootElkNode: ElkNode,
  nodes: INode[],
  edges: IEdge[],
): { nodes: INode[]; edges: IEdge[] } {
  const checkChildren = (currentRootElkNode: ElkNode) => {
    const node = nodes.find((o) => o.id === currentRootElkNode.id)
    if (node) {
      node.x = currentRootElkNode.x ?? 0
      node.y = currentRootElkNode.y ?? 0
    }
    if (currentRootElkNode.children) {
      for (const children of currentRootElkNode.children) {
        checkChildren(children)
      }
    }
  }
  checkChildren(rootElkNode)

  return {
    nodes: nodes,
    edges: edges,
  }
}
